import { ChangePasswordSuccess } from "./ChangePasswordSuccess/ChangePasswordSuccess";
import { Form } from "./Form/Form";

export const ChangePassword = {
  ChangePasswordSuccess,
  Form,
};